export default `
  subscription onUpdateProjectOwner {
    onUpdateProjectOwner {
      id
      name
      organisationId
      organisation {
        id
        name
        userId
        user {
          id
          firstname
          lastname
        }
        createdAt
      }
    }
  }
`
